import { api } from "@/lib/api";

// Sprint 2 — tenancy + academic structure API helpers
export const TenantsAPI = {
  list: (params) => api.get("/tenants", { params }).then((r) => r.data),
  get: (id) => api.get(`/tenants/${id}`).then((r) => r.data),
  create: (body) => api.post("/tenants", body).then((r) => r.data),
  update: (id, patch) => api.patch(`/tenants/${id}`, patch).then((r) => r.data),
  remove: (id) => api.delete(`/tenants/${id}`).then((r) => r.data),
  resetDemo: (id) => api.post(`/tenants/${id}/reset-demo`).then((r) => r.data),
  onboard: (body) => api.post("/tenants/onboard", body).then((r) => r.data),
};

export const InstitutionsAPI = {
  list: (params) => api.get("/institutions", { params }).then((r) => r.data),
  create: (body) => api.post("/institutions", body).then((r) => r.data),
  update: (id, patch) => api.patch(`/institutions/${id}`, patch).then((r) => r.data),
  remove: (id) => api.delete(`/institutions/${id}`).then((r) => r.data),
};

export const CampusesAPI = {
  list: (params) => api.get("/campuses", { params }).then((r) => r.data),
  stats: (params) => api.get("/campuses/stats", { params }).then((r) => r.data),
  create: (body) => api.post("/campuses", body).then((r) => r.data),
  update: (id, patch) => api.patch(`/campuses/${id}`, patch).then((r) => r.data),
  remove: (id) => api.delete(`/campuses/${id}`).then((r) => r.data),
};

export const YearsAPI = {
  list: (params) => api.get("/academic-years", { params }).then((r) => r.data),
  create: (body) => api.post("/academic-years", body).then((r) => r.data),
  update: (id, patch) => api.patch(`/academic-years/${id}`, patch).then((r) => r.data),
  remove: (id) => api.delete(`/academic-years/${id}`).then((r) => r.data),
};

export const ClassesAPI = {
  list: (params) => api.get("/classes", { params }).then((r) => r.data),
  create: (body) => api.post("/classes", body).then((r) => r.data),
  update: (id, patch) => api.patch(`/classes/${id}`, patch).then((r) => r.data),
  remove: (id) => api.delete(`/classes/${id}`).then((r) => r.data),
};

export const SectionsAPI = {
  list: (params) => api.get("/sections", { params }).then((r) => r.data),
  create: (body) => api.post("/sections", body).then((r) => r.data),
  update: (id, patch) => api.patch(`/sections/${id}`, patch).then((r) => r.data),
  remove: (id) => api.delete(`/sections/${id}`).then((r) => r.data),
  myClasses: () => api.get("/sections/my-classes").then((r) => r.data),
};

export const SubjectsAPI = {
  list: (params) => api.get("/subjects", { params }).then((r) => r.data),
  create: (body) => api.post("/subjects", body).then((r) => r.data),
  update: (id, patch) => api.patch(`/subjects/${id}`, patch).then((r) => r.data),
  remove: (id) => api.delete(`/subjects/${id}`).then((r) => r.data),
};

export const BulkImportAPI = {
  sample: (resource) => api.get(`/bulk-import/sample/${resource}`).then((r) => r.data),
  upload: (resource, file, { tenantId, institutionId, campusId, dryRun } = {}) => {
    const fd = new FormData();
    fd.append("file", file);
    if (tenantId) fd.append("tenant_id", tenantId);
    if (institutionId) fd.append("institution_id", institutionId);
    if (campusId) fd.append("campus_id", campusId);
    if (dryRun) fd.append("dry_run", "true");
    return api
      .post(`/bulk-import/${resource}`, fd, { headers: { "Content-Type": "multipart/form-data" } })
      .then((r) => r.data);
  },
};
